import { Type } from 'class-transformer';
import { InsuranceDocumentFileTypeResultDto } from './insurance-document-file-type-result-dto';
import { VendorInsuranceRawDto } from '../../../shared-ciramail-module/_models/vendor-insurance-raw-dto';

export class VendorInsuranceDocumentEditorResultDto {
    @Type(() => InsuranceDocumentFileTypeResultDto)
    fileTypes: InsuranceDocumentFileTypeResultDto[];

    @Type(() => VendorInsuranceRawDto)
    insuranceDocument: VendorInsuranceRawDto;
}
